module.exports = __webpack_public_path__ + "img/w18b.b8531469.jpg";